"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileCTAVariantsComponentsMap = exports.MobileCTAVariants = exports.CTABannerMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const MobileCompactCTABanner_1 = require("./MobileCompactCTABanner");
const MobileDefaultCTABanner_1 = require("./MobileDefaultCTABanner");
const MobileExpandedCTABanner_1 = require("./MobileExpandedCTABanner");
/**
 * CTA banner message
 */
function CTABannerMessage({ openInSnapchatLink }) {
    return openInSnapchatLink ? ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { description: "Button text to inform the user to open Snapchat to watch more content.", defaultMessage: "Open in Snapchat", id: "P6YGQz" })) : ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { description: "A button prompting the user to download the Snapchat app to find more content", defaultMessage: "Download Snapchat to find more", id: "N7iI/k" }));
}
exports.CTABannerMessage = CTABannerMessage;
exports.MobileCTAVariants = {
    BLACK_AND_YELLOW_DEFAULT: "BLACK_AND_YELLOW_DEFAULT",
    COMPACT: "COMPACT",
    EXPANDED_TRAY: "EXPANDED_TRAY",
    EXPANDED_TRAY_WITH_OVERLAY: "EXPANDED_TRAY_WITH_OVERLAY",
};
exports.MobileCTAVariantsComponentsMap = {
    [exports.MobileCTAVariants.BLACK_AND_YELLOW_DEFAULT]: {
        Component: MobileDefaultCTABanner_1.MobileDefaultCTABanner,
    },
    [exports.MobileCTAVariants.COMPACT]: {
        Component: MobileCompactCTABanner_1.MobileCompactCTABanner,
        replaceFooter: true,
    },
    [exports.MobileCTAVariants.EXPANDED_TRAY]: {
        Component: MobileExpandedCTABanner_1.MobileExpandedCTABanner,
    },
    [exports.MobileCTAVariants.EXPANDED_TRAY_WITH_OVERLAY]: {
        Component: (props) => ((0, jsx_runtime_1.jsx)(MobileExpandedCTABanner_1.MobileExpandedCTABanner, { ...props, showBackdrop: true })),
    },
};
//# sourceMappingURL=index.js.map